import React, { Component } from "react";

import {
  CCard,
  CButton,
  CCardBody,
  CCardFooter,
  CInput,
  CInputGroup,
  CInputGroupAppend,
  CNav,
  CNavItem,
  CNavLink,
  CDropdown,
  CDropdownToggle,
  CDropdownMenu,
  CDropdownItem
} from "@coreui/react";
import { connect } from "react-redux";
import { toastr } from "react-redux-toastr";
import { bindActionCreators } from "redux";

import JitsiModal from "./jitsi";
import Statistics from "./statistics";
import { logout } from "../../../../actions/baseActions";
import { setObj } from "../../../../actions/noteActions";
import Breadcrumb from "../../../../components/Breadcrumb";
import Cards from "../../../../components/Cards/Cards";
import CommunityContent from "../../../../components/CommunityContent";
import Interface from "../../../../components/Interface";
import Loading from "../../../../components/Loading";
import ProtectedRoute from "../../../../components/ProtectedRoute";
import URL from "../../../../config/api";
import axios from "../../../../config/axios";
import { hasGameficandusModule } from "../../../../utils/accessSession";
import "./styles.css";

class ClassroomShow extends Component {
  constructor(props) {
    super(props);
    this.state = {
      loading: true,
      // community_box: {},
      documents_box: {},
      discussions_box: {},
      activities_box: {},
      recordings_box: {},
      // members_box: {},
      // content: "main",
      // inputSearch: "",
      search: "",
      room: null,
      // tab: 1,
      key: 0,
      iframe: false,
      url: null,
      title: null,
      meet: null,
      jitsi: false,
      statistics: false,
      // currentUser: null,
      listSegmentsAllowed: this.props.user.user_modules,
      isAlagoasGroup: false,
      // Os dois nascem falsos para a aba não piscar na tela de quem não
      // deveria vê-la: só ligam depois da resposta do backend.
      // `rankingVisible` é o interruptor da turma (o que vale para o aluno);
      // `rankingCanManage` é quem pode mexer nele — para esse a aba aparece
      // sempre, liberada ou não, porque ele precisa ver o ranking para decidir
      // se libera.
      rankingVisible: false,
      rankingCanManage: false
    };
  }

  openActivity = data => {};

  openDocument = data => {};

  error(response) {
    if (response === "Unauthorized") {
      this.props.logout(this.props.user.token);
    } else {
      toastr.error("Falha", response);
    }
  }

  componentDidMount() {
    const { id } = this.props.match.params;

    this.props.setObj(21, id, this.props.currentRoute);
    axios
      .get(`${URL.api}community/room/singleView/${id}`, {
        headers: { Authorization: `Bearer ${this.props.user.token}` }
      })
      .then(
        resp => {
          this.setState({
            room: resp.data.data,
            // members_box: {
            //   type: 4,
            //   items: resp.data.data.room_user.slice(0, 6)
            // },
            loading: false
          });
        },
        error => {
          this.error("Não foi possível obter informações sobre a turma!");
        }
      );

    axios
      .post(
        `${URL.api}activity/activity/filter`,
        { user: this.props.user.user.id, room: id, types: [1, 4] },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          this.setState({
            activities_box: { type: 2, items: resp.data.data.slice(0, 4) }
          });
        },
        error => {
          this.error(
            "Não foi possível obter informações sobre as atividades da turma!"
          );
        }
      );

    axios
      .post(
        `${URL.api}content/doc/listRoom`,
        { room_id: id, user_id: this.props.user.user.id },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          this.setState({
            documents_box: {
              type: 5,
              items: resp.data.data
                .filter(item => item.folder === false)
                .slice(0, 4)
            }
          });
        },
        error => {
          this.error(
            "Não foi possível obter informações sobre os documentos da turma!"
          );
        }
      );

    axios
      .post(
        `${URL.api}community/room_recording/list`,
        { room: id },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          this.setState({
            recordings_box: { type: 6, items: resp.data.data.slice(0, 4) }
          });
        },
        error => {
          this.error(
            "Não foi possível obter informações sobre as gravações da turma!"
          );
        }
      );

    axios
      .post(
        `${URL.api}communication/forum/list`,
        { room_id: id, user_id: this.props.user.user.id },
        { headers: { Authorization: `Bearer ${this.props.user.token}` } }
      )
      .then(
        resp => {
          this.setState({
            discussions_box: {
              type: 3,
              items: resp.data.data
                .filter(item => item.forum_id === null)
                .slice(0, 4)
            }
          });
        },
        error => {
          this.error(
            "Não foi possível obter informações sobre os fóruns da turma!"
          );
        }
      );

    // Ranking: a aba só existe se o professor tiver liberado a turma. A falha
    // aqui é silenciosa de propósito — 403 é resposta esperada para quem não
    // tem acesso, e não é assunto do aluno.
    if (hasGameficandusModule(this.props.user.user_modules)) {
      axios
        .get(`${URL.api}gamification/ranking/visibility`, {
          params: { room_id: id },
          headers: { Authorization: `Bearer ${this.props.user.token}` }
        })
        .then(resp => {
          this.setState({
            rankingVisible: Boolean(resp.data.data?.visible_to_students),
            rankingCanManage: Boolean(resp.data.data?.can_manage)
          });
        })
        .catch(() => {});
    }

    if (this.props.user.user_roles) {
      let aux = this.props.user.user_roles.find(
        elem => elem.group_name === "Escola 10 Digital"
      );
      if (aux) {
        this.setState({ isAlagoasGroup: true });
      }
    }
  }

  click() {
    let objDocuments = {
      title: "Documentos"
    };
    let objDiscussions = {
      title: "Discussões"
    };
    this.setState(
      () => ({
        loading: true,
        documents_box: objDocuments,
        discussions_box: objDiscussions
      }),
      () => {
        // this.state.socket.emit('userConected', data);
      }
    );
  }

  checkAdm() {
    if (this.props.user.user_roles[0].role_id === 4) {
      return (
        this.props.user.user_roles[0].school_id ===
        this.state.room.room.school_id
      );
    }
    if (this.props.user.user_roles[0].role_id === 2) {
      return (
        this.props.user.user_roles[0].group_id === this.state.room.room.group_id
      );
    }
    if (this.props.user.user_roles[0].role_id === 3) {
      return (
        this.props.user.user_roles[0].region_id ===
        this.state.room.room.region_id
      );
    }
    return false;
  }

  hasPrivilege() {
    // Checa se o usuário atual é um administrador escolar
    if (this.checkAdm()) return true;

    if (this.state.room.room.class) {
      const user = this.state.room.room_user.find(
        item => item.user_id === this.props.user.user.id
      );

      if (user) {
        return user.administrator;
      }
    }

    this.props.history.push("/classroom/me");
  }

  navigate(pathname) {
    window.history.pushState("", "", pathname);
    this.setState(state => ({ key: (state.key + 1) % 2 }));
  }

  getContent() {
    const path = window.location.pathname.substr(1).split("/");
    if (path.length === 2) {
      return "main";
    }
    if (path.length === 3) {
      return path[2];
    }

    return `${path[2]}SingleView`;
  }

  openUrl(title, url) {
    this.setState({
      iframe: true,
      url,
      title
    });
  }

  openMeet = url => {
    this.setState(
      {
        meet: url
      },
      () => {
        window.open(this.state.meet);
      }
    );
  };

  getJitsiRoomName() {
    if (!this.state.room) return "";

    const removeSpecial = str => {
      if (str === null) return "";

      str = str.toLowerCase();
      str = str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
      str = str.replace(/[^\w\s]/gi, "");

      return str.replace(" ", "");
    };

    return `${removeSpecial(this.state.room.room.name)}-geral`;
  }

  /**
   * A aba Ranking existe para quem pode administrar a turma (sempre) e para o
   * aluno só quando o interruptor daquela turma está ligado. Nos dois casos
   * exige o módulo Gameficandus.
   */
  showRankingTab() {
    return (
      hasGameficandusModule(this.props.user.user_modules) &&
      (this.state.rankingCanManage || this.state.rankingVisible)
    );
  }

  userHasSegmentGroup(segmentName) {
    // Percorre o array de objetos
    for (let i = 0; i < this.state.listSegmentsAllowed.length; i++) {
      // Verifica se o valor do 'name' é igual ao 'nameToFind'
      if (this.state.listSegmentsAllowed[i].name === segmentName) {
        return true; // Se encontrou, retorna true
      }
    }
    return false; // Se não encontrou, retorna false
  }

  render() {
    const room = this.state.room && this.state.room.room;
    const { id } = this.props.match.params;

    const modules =
      this.props.user.user_modules?.map(module => module.id) || [];

    const isCompletePlatform = modules.includes(2);
    const hasAdaptative = modules.includes(17);

    return (
      <React.Fragment>
        <Breadcrumb
          current={this.props.currentRoute}
          items={[{ path: "/classroom/me", to: "/classroom/me" }]}
        />
        {this.state.iframe && (
          <Interface
            show={this.state.iframe}
            url={this.state.url}
            title={this.state.title}
            botoes={0}
            onClose={() => this.setState({ iframe: false })}
          />
        )}
        <JitsiModal
          show={this.state.jitsi}
          room={this.getJitsiRoomName()}
          onClose={() => this.setState({ jitsi: false })}
          teacher={this.props.general.active_roles.role_id !== 7}
          user={this.props.user.user.name}
          title="Reunião"
          token={this.props.user.token}
          room_id={id}
        />
        {this.state.loading ? (
          <Loading top="45" left="50" />
        ) : (
          <>
            <Statistics
              show={this.state.statistics}
              onClose={() => this.setState({ statistics: false })}
              room_id={id}
              name={room.name}
            />
            <CCard>
              <CCardBody
                className="d-flex align-items-end bg-primary text-white classroom-banner"
                style={{
                  padding: "1rem 1.25rem",
                  height: "120px",
                  borderTopRightRadius: "0.25rem",
                  borderTopLeftRadius: "0.25rem"
                }}
              >
                <div
                  className="d-flex text-ellipsis classroom-banner-row"
                  style={{ flex: 1 }}
                >
                  <h3
                    className="community-room-show-title mr-2 text-ellipsis"
                    style={{ minWidth: "100px" }}
                  >
                    {room.name}
                  </h3>
                  <div className="d-flex align-items-center justify-content-end text-ellipsis classroom-banner-meta">
                    {room.external_id && (
                      <div className="text-muted text-ellipsis mr-4">
                        <i className="fa fa-graduation-cap mr-2"></i>{" "}
                        {room.external_id}
                      </div>
                    )}
                    <div className="text-muted text-ellipsis">
                      <i className="fa fa-institution mr-2"></i>{" "}
                      {room.school_name}
                    </div>
                    {/* {room.hasGoogle && (f
                      <Meet
                        className="ml-4 text-muted community-room-header-link text-ellipsis"
                        classId={this.state.room.room.id}
                        meet={this.state.room.room.meet}
                        openMeet={this.openMeet}
                      />
                    )} */}
                    {room.hasGoogle &&
                      this.userHasSegmentGroup("Classroom") && (
                        <div
                          className="ml-4 text-muted btn-jitsi text-ellipsis"
                          onClick={() =>
                            window.open(
                              this.state.room.room.google_classroom_url,
                              "_blank"
                            )
                          }
                        >
                          <i className="fa fa-google mr-2"></i> Classroom
                        </div>
                      )}
                    {isCompletePlatform &&
                      this.userHasSegmentGroup("Ao Vivo") && (
                        <div
                          className="ml-4 text-muted btn-jitsi text-ellipsis"
                          onClick={() =>
                            window.open(
                              `/classroom/${this.state.room.room.id}/meeting`,
                              "_blank"
                            )
                          }
                        >
                          <i className="fa fa-video-camera mr-2"></i> Sala de
                          aula
                        </div>
                      )}
                  </div>
                </div>
              </CCardBody>
              <CCardFooter className="p-0">
                <div className="d-flex w-100">
                  <div
                    className="scrollbar-config"
                    style={{
                      display: "flex",
                      flexWrap: "nowrap",
                      height: "100%",
                      width: "100%",
                      flex: 1
                      // marginRight: "1rem"
                    }}
                  >
                    <CNav
                      variant="tabs"
                      className="nav-underline nav-underline-primary flex-nowrap w-100 justify-content-between justify-content-md-start"
                      style={{ whiteSpace: "nowrap" }}
                    >
                      <div className="m-0 d-flex">
                        <CNavItem>
                          <CNavLink
                            className="h-100 d-flex align-items-center justify-content-center"
                            active={this.getContent().includes("main")}
                            onClick={() => this.navigate(`/classroom/${id}`)}
                          >
                            Avisos
                          </CNavLink>
                        </CNavItem>
                        {isCompletePlatform &&
                          this.userHasSegmentGroup("Ao Vivo") && (
                            <CNavItem>
                              <CNavLink
                                className="h-100 d-flex align-items-center justify-content-center"
                                active={this.getContent().includes("live")}
                                onClick={() =>
                                  this.navigate(`/classroom/${id}/lives`)
                                }
                              >
                                Ao vivo
                              </CNavLink>
                            </CNavItem>
                          )}
                        <CNavItem>
                          <CNavLink
                            className="h-100 d-flex align-items-center justify-content-center"
                            active={this.getContent().includes("activit")}
                            onClick={() =>
                              this.navigate(`/classroom/${id}/activities`)
                            }
                          >
                            Atividades
                          </CNavLink>
                        </CNavItem>
                        {/* Em mobile a linha fica com no máximo 3 abas: esta
                            aparece só a partir de md, e abaixo disso vive no
                            menu "..." — mesmo padrão dos demais itens. O
                            wrapper carrega as classes de breakpoint para não
                            alterar o display do próprio CNavItem no desktop. */}
                        {this.hasPrivilege() &&
                          hasGameficandusModule(
                            this.props.user.user_modules
                          ) && (
                            <div className="d-none d-md-flex">
                              <CNavItem>
                                <CNavLink
                                  className="h-100 d-flex align-items-center justify-content-center"
                                  active={this.getContent().includes(
                                    "certificate"
                                  )}
                                  onClick={() =>
                                    this.navigate(
                                      `/classroom/${id}/certificates`
                                    )
                                  }
                                >
                                  Certificados
                                </CNavLink>
                              </CNavItem>
                            </div>
                          )}
                        {/* Ranking: mesmo tratamento de breakpoint dos
                            Certificados — a partir de md fica na linha de
                            abas, abaixo disso vive no menu "...". */}
                        {this.showRankingTab() && (
                          <div className="d-none d-md-flex">
                            <CNavItem>
                              <CNavLink
                                className="h-100 d-flex align-items-center justify-content-center"
                                active={this.getContent().includes("ranking")}
                                onClick={() =>
                                  this.navigate(`/classroom/${id}/ranking`)
                                }
                              >
                                Ranking
                              </CNavLink>
                            </CNavItem>
                          </div>
                        )}
                      </div>
                      <CDropdown inNav>
                        <CDropdownToggle
                          color="white"
                          className="d-md-none card-header-action remove-caret h-100 d-flex align-items-center justify-content-center"
                        >
                          <i className="fa fa-ellipsis-v"></i>
                        </CDropdownToggle>
                        <CDropdownMenu
                          placement="bottom-end"
                          className="classroom-tab-menu"
                        >
                          {this.hasPrivilege() &&
                            hasGameficandusModule(
                              this.props.user.user_modules
                            ) && (
                              <CDropdownItem
                                active={this.getContent().includes(
                                  "certificate"
                                )}
                                onClick={() =>
                                  this.navigate(`/classroom/${id}/certificates`)
                                }
                              >
                                Certificados
                              </CDropdownItem>
                            )}
                          {this.showRankingTab() && (
                            <CDropdownItem
                              active={this.getContent().includes("ranking")}
                              onClick={() =>
                                this.navigate(`/classroom/${id}/ranking`)
                              }
                            >
                              Ranking
                            </CDropdownItem>
                          )}
                          {hasAdaptative && !this.state.isAlagoasGroup && (
                            <CDropdownItem
                              active={this.getContent().includes("trail")}
                              onClick={() =>
                                this.navigate(`/classroom/${id}/trails`)
                              }
                            >
                              Trilhas
                            </CDropdownItem>
                          )}
                          <CDropdownItem
                            active={this.getContent().includes("forum")}
                            onClick={() =>
                              this.navigate(`/classroom/${id}/forums`)
                            }
                          >
                            Fórum
                          </CDropdownItem>
                          {isCompletePlatform && (
                            <CDropdownItem
                              active={this.getContent().includes("record")}
                              onClick={() =>
                                this.navigate(`/classroom/${id}/recordings`)
                              }
                            >
                              Gravações
                            </CDropdownItem>
                          )}
                          {this.hasPrivilege() && (
                            <CDropdownItem
                              active={this.getContent().includes("user")}
                              onClick={() =>
                                this.navigate(`/classroom/${id}/users`)
                              }
                            >
                              Membros
                            </CDropdownItem>
                          )}
                          {this.hasPrivilege() && (
                            <CDropdownItem
                              active={this.getContent().includes("group")}
                              onClick={() =>
                                this.navigate(`/classroom/${id}/groups`)
                              }
                            >
                              Grupos
                            </CDropdownItem>
                          )}
                          {this.hasPrivilege() && (
                            <CDropdownItem
                              onClick={() =>
                                this.setState({ statistics: true })
                              }
                            >
                              Estatísticas
                            </CDropdownItem>
                          )}
                        </CDropdownMenu>
                      </CDropdown>
                      <div className="d-none d-md-flex">
                        {hasAdaptative && !this.state.isAlagoasGroup && (
                          <CNavItem>
                            <CNavLink
                              className="h-100 d-flex align-items-center justify-content-center"
                              active={this.getContent().includes("trail")}
                              onClick={() =>
                                this.navigate(`/classroom/${id}/trails`)
                              }
                            >
                              Trilhas
                            </CNavLink>
                          </CNavItem>
                        )}
                        <CNavItem>
                          <CNavLink
                            className="h-100 d-flex align-items-center justify-content-center"
                            active={this.getContent().includes("doc")}
                            onClick={() =>
                              this.navigate(`/classroom/${id}/docs`)
                            }
                          >
                            Documentos
                          </CNavLink>
                        </CNavItem>
                        <CNavItem>
                          <CNavLink
                            className="h-100 d-flex align-items-center justify-content-center"
                            active={this.getContent().includes("forum")}
                            onClick={() =>
                              this.navigate(`/classroom/${id}/forums`)
                            }
                          >
                            Fórum
                          </CNavLink>
                        </CNavItem>
                        {isCompletePlatform &&
                          this.userHasSegmentGroup("Ao Vivo") && (
                            <CNavItem>
                              <CNavLink
                                className="h-100 d-flex align-items-center justify-content-center"
                                active={this.getContent().includes("record")}
                                onClick={() =>
                                  this.navigate(`/classroom/${id}/recordings`)
                                }
                              >
                                Gravações
                              </CNavLink>
                            </CNavItem>
                          )}
                        {this.hasPrivilege() && (
                          <CNavItem>
                            <CNavLink
                              className="h-100 d-flex align-items-center justify-content-center"
                              active={this.getContent().includes("user")}
                              onClick={() =>
                                this.navigate(`/classroom/${id}/users`)
                              }
                            >
                              Membros
                            </CNavLink>
                          </CNavItem>
                        )}
                        {/* Grupos: mesmo tratamento de breakpoint dos
                            Certificados e do Ranking — a partir de md fica na
                            linha de abas, abaixo disso vive no menu "...". */}
                        {this.hasPrivilege() && (
                          <CNavItem>
                            <CNavLink
                              className="h-100 d-flex align-items-center justify-content-center"
                              active={this.getContent().includes("group")}
                              onClick={() =>
                                this.navigate(`/classroom/${id}/groups`)
                              }
                            >
                              Grupos
                            </CNavLink>
                          </CNavItem>
                        )}
                        {this.hasPrivilege() && (
                          <CNavItem>
                            <CNavLink
                              className="h-100 d-flex align-items-center justify-content-center"
                              onClick={() =>
                                this.setState({ statistics: true })
                              }
                            >
                              Estatísticas
                            </CNavLink>
                          </CNavItem>
                        )}
                      </div>
                    </CNav>
                  </div>
                  {/* <div
                    style={{
                      width: "240px",
                      display: "flex",
                      flexDirection: "row",
                      alignItems: "center",
                      paddingRight: "1.25rem"
                    }}
                    className="py-2 d-none d-sm-flex"
                  >
                    <CInputGroup
                      className="d-flex justify-content-end"
                      style={{ flexWrap: "nowrap" }}
                    >
                      <CInput
                        className="form-control"
                        type="text"
                        style={{ width: "auto", height: "auto" }}
                        placeholder="Pesquisar"
                        onChange={e =>
                          this.setState({ inputSearch: e.target.value })
                        }
                      ></CInput>
                      <CInputGroupAppend>
                        <CButton
                          color="light"
                          style={{ border: "1px solid #d8dbe0" }}
                          onClick={() =>
                            this.setState(state => ({
                              search: state.inputSearch
                            }))
                          }
                        >
                          <i className="fa fa-search text-muted m-0"></i>
                        </CButton>
                      </CInputGroupAppend>
                    </CInputGroup>
                  </div> */}
                </div>
              </CCardFooter>
            </CCard>
            <div className="row">
              <div className="col-lg-9 col-sm-12">
                <CommunityContent
                  key={this.state.key}
                  hasPrivilege={this.hasPrivilege()}
                  content={this.getContent()}
                  search={this.state.search}
                  history={this.props.history}
                  navigate={this.navigate.bind(this)}
                  match={this.props.match}
                  currentRoute={this.props.currentRoute}
                  room={this.state.room}
                />
              </div>
              <div className="col-lg-3 col-sm-12">
                <Cards
                  header="Atividades recentes"
                  body={this.state.activities_box}
                  footer=""
                  function={allocationId =>
                    this.props.history.push(`/activity/do/${allocationId}`)
                  }
                />
                {isCompletePlatform && this.userHasSegmentGroup("Ao Vivo") && (
                  <Cards
                    header="Gravações recentes"
                    body={this.state.recordings_box}
                    footer=""
                    function={url => window.open(url, "_blank").focus()}
                  />
                )}
                <Cards
                  header="Documentos recentes"
                  body={this.state.documents_box}
                  footer=""
                  openUrl={(title, url) => this.openUrl(title, url)}
                  function={this.openDocument}
                />
                <Cards
                  header="Discussões recentes"
                  body={this.state.discussions_box}
                  footer=""
                  function={id =>
                    this.navigate(
                      `/classroom/${this.props.match.params.id}/forums/${id}`
                    )
                  }
                />
              </div>
            </div>
            <ProtectedRoute routeId={this.props.currentRoute} />
          </>
        )}
      </React.Fragment>
    );
  }
}

const mapStateToProps = state => ({
  user: state.user,
  general: state.general,
  profile: state.profile,
  form: state.form
});

function mapDispatchToProps(dispatch) {
  return bindActionCreators(
    {
      logout,
      setObj
    },
    dispatch
  );
}

export default connect(mapStateToProps, mapDispatchToProps)(ClassroomShow);
